import ReactDOM from "react-dom";
import LoginAPP from "./containers/login/index";
ReactDOM.render(
        <LoginAPP />,
    document.getElementById('login_root')
)